// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QHMV5fMefRLkJJ {
  border-radius: var(--ds-border-radius-200, 8px);
}
.QHMV5fMefRLkJJ:focus,
.QHMV5fMefRLkJJ:active,
.QHMV5fMefRLkJJ.CMkDm_t2eQiZIO {
  outline-offset: 2px;
  outline: var(--ds-border-focused, #388bff) auto 2px !important;
  outline-offset: 2px !important;
}
.mac .QHMV5fMefRLkJJ:focus,
.mac .QHMV5fMefRLkJJ:active,
.mac .QHMV5fMefRLkJJ.CMkDm_t2eQiZIO {
  outline-color: -webkit-focus-ring-color !important;
}
.QHMV5fMefRLkJJ:focus .mac.firefox,
.QHMV5fMefRLkJJ:active .mac.firefox,
.QHMV5fMefRLkJJ.CMkDm_t2eQiZIO .mac.firefox {
  outline-color: AccentColor !important;
}
.QHMV5fMefRLkJJ.A_DOCEUvbsR0Vx {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 120px;
  min-height: 108px;
  margin: var(--ds-space-050, 4px);
  overflow: hidden;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  box-shadow: var(--ds-shadow-raised, 1px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
}
.QHMV5fMefRLkJJ.A_DOCEUvbsR0Vx a {
  display: block;
  box-sizing: border-box;
  height: 100%;
}
.QHMV5fMefRLkJJ.A_DOCEUvbsR0Vx a:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.yr1vGcDI4Tu8wG {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.QsXXON350E7TC7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 72px;
}
.QsXXON350E7TC7 svg {
  transform: scale(2);
}
.K9siI9eqNDP476 {
  flex: 1;
  background-color: var(--ds-surface, #ffffff);
}
.ojLfwdPCNkDFq5 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: var(--ds-space-100, 8px);
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
  word-wrap: break-word;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewTile": `QHMV5fMefRLkJJ`,
	"active": `CMkDm_t2eQiZIO`,
	"grid": `A_DOCEUvbsR0Vx`,
	"viewDetails": `yr1vGcDI4Tu8wG`,
	"iconContainer": `QsXXON350E7TC7`,
	"viewNameContainer": `K9siI9eqNDP476`,
	"viewName": `ojLfwdPCNkDFq5`
};
export default ___CSS_LOADER_EXPORT___;
